import { APP_COLORS, APP_FONT_WEIGHT, APP_SIZES } from 'constants/vars';
import { FC } from 'react';
import { ParagraphProps as AntParagraphProps } from 'antd/lib/typography/Paragraph';

import { StyledParagraph } from './styled';

export interface IProps extends Omit<AntParagraphProps, 'size' | 'color'> {
  color?: keyof typeof APP_COLORS;
  textAlign?: 'center' | 'left' | 'right';
  size?: keyof typeof APP_SIZES;
  fontWeight?: keyof typeof APP_FONT_WEIGHT;
  lineHeight?: number;
}

const Paragraph: FC<IProps> = ({
  children,
  color = 'text-100',
  textAlign,
  size = '16',
  fontWeight = '400',
  lineHeight,
  ...rest
}) => (
  <StyledParagraph
    $color={color}
    $lineHeight={lineHeight}
    $fontWeight={fontWeight}
    $textAlign={textAlign}
    $size={size}
    {...rest}
  >
    {children}
  </StyledParagraph>
);

export default Paragraph;
